function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("linearGradient", {
  gradientTransform: "matrix(1.1568628,0,0,1.1568628,-5.8975408,-42.658444)",
  gradientUnits: "userSpaceOnUse",
  y2: 292.84225,
  x2: 39.876488,
  y1: 225.37349,
  x1: 39.876488,
  id: "linearGradient4575",
  xlinkHref: "#linearGradient4573"
});

var _ref3 =
/*#__PURE__*/
React.createElement("metadata", {
  id: "metadata5"
});

var _ref4 =
/*#__PURE__*/
React.createElement("flowRegion", {
  id: "flowRegion4557"
}, React.createElement("rect", {
  y: 145.71428,
  x: 1.4285715,
  height: 72.14286,
  width: 300.71429,
  id: "rect4559"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("flowPara", {
  id: "flowPara4561"
});

var SvgBaseIcon = function SvgBaseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 79.374998 79.375002",
    height: 300,
    width: 300,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("defs", {
    id: "defs2"
  }, React.createElement("linearGradient", {
    id: "linearGradient4573"
  }, React.createElement("stop", {
    id: "stop4569",
    offset: 0,
    style: {
      stopColor: "#1e5799",
      stopOpacity: 1
    }
  }), React.createElement("stop", {
    id: "stop4571",
    offset: 1,
    style: {
      stopColor: "#5a86a8",
      stopOpacity: 1
    }
  })), _ref2), _ref3, React.createElement("g", {
    transform: "translate(0,-217.62498)",
    id: "layer1"
  }, React.createElement("circle", {
    r: 39.026043,
    cy: 257.31247,
    cx: 39.6875,
    id: "path4567",
    style: {
      fill: "url(#linearGradient4575)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.3060866
    }
  }), React.createElement("rect", {
    style: {
      strokeWidth: 0.26458332,
      fillOpacity: 0,
      fill: "#e57990",
      stroke: "none"
    },
    y: 217.62498,
    x: 0,
    height: 79.375,
    width: 79.375,
    id: "rect18"
  }), React.createElement("flowRoot", {
    style: {
      fill: "black",
      fillOpacity: 1,
      stroke: "none",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      letterSpacing: 0,
      wordSpacing: 0
    },
    id: "flowRoot4555"
  }, _ref4, _ref5), React.createElement("path", {
    d: "m 50.641249,242.10424 -5.6515,28.6385 q -0.762,3.6195 -1.9685,6.0325 -1.2065,2.4765 -3.048,4.2545 -1.778,1.8415 -4.318,3.2385 -2.54,1.4605 -5.9055,3.1115 l -3.556,-6.858 q 2.159,-0.9525 3.7465,-1.905 1.524,-0.9525 2.6035,-2.159 1.0795,-1.2065 1.778,-2.667 0.6985,-1.4605 1.0795,-3.4925 l 5.588,-28.194 z m -2.794,-14.859 q 2.794,0 4.064,1.397 1.27,1.3335 1.27,3.683 0,2.286 -1.651,4.0005 -1.5875,1.651 -4.318,1.651 -2.7305,0 -4.0005,-1.397 -1.27,-1.397 -1.27,-3.6195 0,-2.286 1.524,-4.0005 1.5875,-1.7145 4.3815,-1.7145 z",
    style: {
      fontStyle: "italic",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "63.5px",
      lineHeight: 1.25,
      fontFamily: "Amaranth",
      InkscapeFontSpecification: "'Amaranth Bold Italic'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    id: "path4615"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBaseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/baseIcon.1e60504b.svg";
export { ForwardRef as ReactComponent };